module.exports = __webpack_public_path__ + "img/bi_house-door-fill.d9eb2ba9.svg";